'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardImageForBrand = exports.creditCardMaxLength = exports.DiscoverPrefix = exports.MastercardPrefix = exports.VisaPrefix = exports.AmexPrefix = exports.CVVLength = exports.AmexCVVLength = exports.ZIPCodeMaxLength = exports.MaxCreditCardLength = exports.AmexMaxCreditCardLength = exports.RoutingNumberMaxLength = exports.formattedCreditCardExpiration = exports.postalCodeRequiredForCountry = exports.sanitizePostalCodeForCountry = exports.maximumPostalCodeLengthForCountry = exports.formattedPostalCode = exports.postalCodeInputMode = exports.postalCodeNameForCountry = exports.displayNameForSubdivision = exports.emojiForRegion = exports.displayNameForRegion = exports.formattedWebsite = exports.formattedPercentage = exports.formattedNumber = exports.formattedPrice = exports.formattedDateTime = exports.formattedMessage = exports.formattedPhoneNumber = exports.validateEmailAddress = exports.allRegionCodes = void 0;
const google_libphonenumber_1 = require("google-libphonenumber");
const lodash_1 = __importDefault(require("lodash"));
const intl_messageformat_1 = __importDefault(require("intl-messageformat"));
const data_json_1 = __importDefault(require("country-region-data/data.json"));
const moment_1 = __importDefault(require("moment"));
const PhoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
// https://www.bis.doc.gov/index.php/policy-guidance/country-guidance/sanctioned-destinations
const SanctionedCountryCodes = [
    'CU',
    'KP',
    'IR',
    'SY', // Syria
];
const CountryRegionData = data_json_1.default.filter((e) => SanctionedCountryCodes.indexOf(e.countryShortCode) === -1);
const DefaultLocale = 'en-US';
const DefaultCurrency = 'USD';
const DefaultLanguage = 'en';
const DefaultCountry = 'US';
const CountriesWithNumericPostalCode = [
    'US',
    'AF',
    'AX',
    'AL',
    'DZ',
    'AS',
    'AR',
    'AM',
    'AU',
    'AT',
    'BH',
    'BD',
    'BY',
    'BE',
    'BT',
    'BA',
    'BR',
    'BG',
    'CV',
    'CL',
    'CN',
    'CX',
    'CC',
    'CO',
    'CR',
    'HR',
    'CU',
    'CY',
    'DK',
    'DO',
    'EC',
    'SV',
    'EG',
    'EE',
    'ET',
    'FI',
    'FR',
    'GE',
    'DE',
    'GL',
    'GU',
    'GT',
    'GN',
    'GW',
    'HT',
    'HU',
    'IS',
    'IN',
    'ID',
    'IQ',
    'IL',
    'IT',
    'JM',
    'JO',
    'KZ',
    'KE',
    'KR',
    'KW',
    'KG',
    'LA',
    'LB',
    'LS',
    'LR',
    'LI',
    'LU',
    'MG',
    'MW',
    'MY',
    'MV',
    'MH',
    'MU',
    'MX',
    'FM',
    'MN',
    'ME',
    'MA',
    'MZ',
    'MM',
    'NA',
    'NP',
    'NZ',
    'NI',
    'NE',
    'NG',
    'NF',
    'MK',
    'MP',
    'NO',
    'OM',
    'PK',
    'PW',
    'PS',
    'PA',
    'PG',
    'PY',
    'PE',
    'PH',
    'PR',
    'RO',
    'RU',
    'SN',
    'RS',
    'SG',
    'ZA',
    'ES',
    'LK',
    'SD',
    'CH',
    'SJ',
    'TW',
    'TJ',
    'TZ',
    'TH',
    'TT',
    'TN',
    'TR',
    'TM',
    'UA',
    'UY',
    'VI',
    'UZ',
    'VE',
    'VN',
    'WF',
    'ZM',
];
const allRegionCodes = CountryRegionData.map((e) => e.countryShortCode);
exports.allRegionCodes = allRegionCodes;
// taken from the email-validator project
// This is taken to reduce dependencies on Pavo projects
function validateEmailAddress(email) {
    const tester = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
    // Thanks to:
    // http://fightingforalostcause.net/misc/2006/compare-email-regex.php
    // http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
    // http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
    if (lodash_1.default.isEmpty(email))
        return false;
    if (email.length > 254)
        return false;
    const valid = tester.test(email);
    if (!valid)
        return false;
    // Further checking of some things regex can't handle
    const parts = email.split('@');
    if (parts[0].length > 64)
        return false;
    const domainParts = parts[1].split('.');
    if (domainParts.some((part) => {
        return part.length > 63;
    })) {
        return false;
    }
    return true;
}
exports.validateEmailAddress = validateEmailAddress;
function formattedPhoneNumber(phoneNumber, country = DefaultCountry) {
    if (lodash_1.default.isEmpty(phoneNumber)) {
        return null;
    }
    try {
        const number = PhoneUtil.parseAndKeepRawInput(phoneNumber, country);
        return PhoneUtil.format(number, google_libphonenumber_1.PhoneNumberFormat.NATIONAL);
    }
    catch (error) {
        return phoneNumber;
    }
}
exports.formattedPhoneNumber = formattedPhoneNumber;
function formattedMessage(format, numberObject, locale = DefaultLocale) {
    const messageFormat = new intl_messageformat_1.default(format, locale);
    return messageFormat.format(numberObject);
}
exports.formattedMessage = formattedMessage;
function formattedDateTime(date, options, locale = DefaultLocale) {
    // ignore all years before 1990
    if (!date || date.getFullYear() <= 1990) {
        return null;
    }
    let dateTimeOptions = {};
    if (lodash_1.default.isEmpty(options)) {
        dateTimeOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        };
    }
    else {
        dateTimeOptions = options;
    }
    return new Intl.DateTimeFormat(locale, dateTimeOptions).format(date);
}
exports.formattedDateTime = formattedDateTime;
function formattedPrice(price, minimumFractionDigits = 2, currency = DefaultCurrency, locale = DefaultLocale, options = {}) {
    return new Intl.NumberFormat(locale, {
        ...options,
        style: 'currency',
        minimumFractionDigits,
        currency,
    }).format(price);
}
exports.formattedPrice = formattedPrice;
function formattedNumber(number, minimumFractionDigits = 0, locale = DefaultLocale, options = {}) {
    return new Intl.NumberFormat(locale, {
        ...options,
        minimumFractionDigits,
    }).format(number);
}
exports.formattedNumber = formattedNumber;
// this functions assumes a number between 0 and 1
function formattedPercentage(number, minimumFractionDigits = 2, locale = DefaultLocale, options = {}) {
    return new Intl.NumberFormat(locale, {
        ...options,
        style: 'percent',
        minimumFractionDigits,
    }).format(number);
}
exports.formattedPercentage = formattedPercentage;
function formattedWebsite(url) {
    if (!url) {
        return null;
    }
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        url = 'http://' + url;
    }
    return url;
}
exports.formattedWebsite = formattedWebsite;
function displayNameForRegion(regionCode, language = DefaultLanguage) {
    try {
        const displayNames = new Intl.DisplayNames([language], {
            type: 'region',
        });
        return displayNames.of(regionCode);
    }
    catch (error) {
        return regionCode;
    }
}
exports.displayNameForRegion = displayNameForRegion;
function emojiForRegion(regionCode) {
    return typeof String.fromCodePoint !== 'undefined'
        ? regionCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : regionCode;
}
exports.emojiForRegion = emojiForRegion;
function displayNameForSubdivision(regionCode, subdivisionCode) {
    if (regionCode == null) {
        return [];
    }
    let subdivisions = [];
    for (let i = 0; i < CountryRegionData.length; i++) {
        if (CountryRegionData[i].countryShortCode === regionCode) {
            subdivisions = CountryRegionData[i].regions;
            break;
        }
    }
    if (lodash_1.default.isEmpty(subdivisions)) {
        return [];
    }
    if (subdivisionCode) {
        for (let i = 0; i < subdivisions.length; i++) {
            if (subdivisions[i].shortCode === subdivisionCode) {
                return subdivisions[i].name;
            }
        }
    }
    const subdivisionsObjects = subdivisions.map((subdivision) => {
        return {
            code: subdivision.shortCode,
            name: subdivision.name,
        };
    });
    subdivisionsObjects.sort((a, b) => a.name.localeCompare(b.name));
    return subdivisionsObjects;
}
exports.displayNameForSubdivision = displayNameForSubdivision;
function postalCodeNameForCountry(countryCode) {
    switch (countryCode) {
        case 'US':
        case 'PH':
            return 'ZIP Code';
        case 'IT':
            return 'CAP';
        case 'BR':
            return 'CEP';
        case 'CR':
            return 'NPA';
        default:
            return 'Postal Code';
    }
}
exports.postalCodeNameForCountry = postalCodeNameForCountry;
function postalCodeInputMode(countryCode) {
    if (CountriesWithNumericPostalCode.indexOf(countryCode) !== -1) {
        return 'numeric';
    }
    return 'text';
}
exports.postalCodeInputMode = postalCodeInputMode;
function formattedPostalCode(zip, countryCode) {
    if (lodash_1.default.isEmpty(zip)) {
        return zip;
    }
    switch (countryCode) {
        case 'CA': {
            // Canadian postal codes are in the format "A1A 1A1"
            // we can assume the zip var already uppercases everything
            if (zip.length <= 3) {
                return zip;
            }
            zip = zip.replace(/\s+/g, '');
            const formattedPostalCode = `${zip.slice(0, 3)} ${zip.slice(3)}`;
            return formattedPostalCode;
        }
        default:
            return zip;
    }
}
exports.formattedPostalCode = formattedPostalCode;
function maximumPostalCodeLengthForCountry(countryCode) {
    switch (countryCode) {
        case 'US':
        case 'AS':
        case 'AX':
            return 5;
        case 'CA':
            // includes the space in between ("A1A 1A1")
            return 7;
        case 'AF':
            return 4;
        default:
            // if no country provided, return something large
            return 1000;
    }
}
exports.maximumPostalCodeLengthForCountry = maximumPostalCodeLengthForCountry;
function sanitizePostalCodeForCountry(value, countryCode) {
    if (CountriesWithNumericPostalCode.indexOf(countryCode) !== -1) {
        return value.replace(/[^\d]/g, '');
    }
    else if (countryCode === 'CA') {
        let upperCaseValue = value.toUpperCase();
        upperCaseValue = upperCaseValue.replace(/\s+/g, '');
        let returnValue = '';
        for (let i = 0; i < upperCaseValue.length; i++) {
            // even indexes are numbers, while odd indexes are letters
            if (i % 2 !== 0) {
                if (isNaN(Number(upperCaseValue[i]))) {
                    return returnValue;
                }
                else {
                    returnValue += upperCaseValue[i];
                }
            }
            else {
                if (!upperCaseValue[i].match(/[A-Z]/i)) {
                    return returnValue;
                }
                else {
                    returnValue += upperCaseValue[i];
                }
            }
        }
        return upperCaseValue;
    }
    else {
        return value;
    }
}
exports.sanitizePostalCodeForCountry = sanitizePostalCodeForCountry;
function postalCodeRequiredForCountry(countryCode) {
    // list from https://www.ups.com/worldshiphelp/WSA/ENU/AppHelp/mergedProjects/CORE/Codes/Countries_Territories_Requiring_Postal_Codes.htm
    const countryList = [
        'DZ',
        'AR',
        'AM',
        'AU',
        'AT',
        'AZ',
        'A2',
        'BD',
        'BY',
        'BE',
        'BA',
        'BR',
        'BN',
        'BG',
        'CA',
        'IC',
        'CN',
        'CO',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EC',
        'EN',
        'EE',
        'FO',
        'FI',
        'FR',
        'GE',
        'DE',
        'GR',
        'GL',
        'GU',
        'GG',
        'HO',
        'HU',
        'IN',
        'ID',
        'IL',
        'IT',
        'JP',
        'JE',
        'KZ',
        'KR',
        'KO',
        'KG',
        'LV',
        'LI',
        'LT',
        'LU',
        'MK',
        'MG',
        'M3',
        'MY',
        'MH',
        'MQ',
        'YT',
        'MX',
        'MN',
        'ME',
        'NL',
        'NZ',
        'NB',
        'NO',
        'PK',
        'PH',
        'PL',
        'PO',
        'PT',
        'PR',
        'RE',
        'RU',
        'SA',
        'SF',
        'CS',
        'SG',
        'SK',
        'SI',
        'ZA',
        'ES',
        'LK',
        'SX',
        'UV',
        'VL',
        'SE',
        'CH',
        'TW',
        'TJ',
        'TH',
        'TU',
        'TN',
        'TR',
        'TM',
        'VI',
        'UA',
        'GB',
        'US',
        'UY',
        'UZ',
        'VA',
        'VN',
        'WL',
        'YA',
    ];
    return countryList.indexOf(countryCode) !== -1;
}
exports.postalCodeRequiredForCountry = postalCodeRequiredForCountry;
// #region Payments function
function formattedCreditCardExpiration(expiryString) {
    const date = (0, moment_1.default)(expiryString, 'MMYY');
    return date.format('MM/YY');
}
exports.formattedCreditCardExpiration = formattedCreditCardExpiration;
const ImagesBucketURL = `https://pavo-ui-images.s3-us-west-2.amazonaws.com`;
// Per ABA Spec
exports.RoutingNumberMaxLength = 9;
// we can assume that all Amex cards have 15 digits, while all others have 16
// Mastercard has some cases where it's 14, but we'll ignore these cases cause it's very rare
exports.AmexMaxCreditCardLength = 15;
exports.MaxCreditCardLength = 16;
exports.ZIPCodeMaxLength = 5;
exports.AmexCVVLength = 4;
exports.CVVLength = 3;
exports.AmexPrefix = 3;
exports.VisaPrefix = 4;
exports.MastercardPrefix = 5;
exports.DiscoverPrefix = 6;
const creditCardMaxLength = (creditCardNumber) => {
    if (creditCardNumber.length > 1) {
        const [firstDigit] = creditCardNumber;
        return Number(firstDigit) === exports.AmexPrefix ? exports.AmexMaxCreditCardLength : exports.MaxCreditCardLength;
    }
    return exports.MaxCreditCardLength;
};
exports.creditCardMaxLength = creditCardMaxLength;
const imageMasterCard = `${ImagesBucketURL}/payments/MasterCard.png`;
const imageVisa = `${ImagesBucketURL}/payments/Visa.png`;
const imageDiscover = `${ImagesBucketURL}/payments/Discover.jpg`;
const imageAmericanExpress = `${ImagesBucketURL}/payments/Amex.png`;
const imageAvatarMasterCard = `${ImagesBucketURL}/payments/avatars/MasterCard.png`;
const imageAvatarVisa = `${ImagesBucketURL}/payments/avatars/Visa.png`;
const imageAvatarDiscover = `${ImagesBucketURL}/payments/avatars/Discover.png`;
const imageAvatarAmericanExpress = `${ImagesBucketURL}/payments/avatars/Amex.png`;
const avatarCreditCardLogos = {
    visa: imageAvatarVisa,
    mastercard: imageAvatarMasterCard,
    discover: imageAvatarDiscover,
    'american express': imageAvatarAmericanExpress,
};
const creditCardLogos = {
    visa: imageVisa,
    mastercard: imageMasterCard,
    discover: imageDiscover,
    'american express': imageAmericanExpress,
};
const altCreditCardLogos = {
    visa: 'Visa logo',
    mastercard: 'MasterCard logo',
    discover: 'Discover logo',
    'american express': 'American Express logo',
};
function CreditCardImageForBrand(brand) {
    return {
        src: creditCardLogos[brand],
        avatar_src: avatarCreditCardLogos[brand],
        alt: altCreditCardLogos[brand],
    };
}
exports.CreditCardImageForBrand = CreditCardImageForBrand;
